<!--
 * @Descripttion: 查看明细(综合服务费订单)-项目服务费未结算订单点击详情的弹窗
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { XrkTable, XrkTableProps, XrkTableRef } from 'xrk-components';

import { comprehensiveViewDetails } from '../data-source/apis';
import {
  indexCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  comprehensiveServiceRateCol,
  comprehensiveServiceAmountCol
} from '../fields/columns';

const props = withDefaults(
  defineProps<{
    id: number;
  }>(),
  {
    id: null
  }
);

const xrkTableRef = ref<XrkTableRef>();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false
  },
  resetBtn: {
    show: false
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    indexCol,
    fullNameCol,
    phoneCol,
    settlementTaskCountCol,
    taskPriceCol,
    projectPayPriceCol,
    comprehensiveServiceRateCol,
    comprehensiveServiceAmountCol
  ]
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    id: props.id
  };
  const data = await comprehensiveViewDetails(reqData);
  return data;
};
</script>
<style lang="scss"></style>
